// SVG pet-themed prop icons for parallax background
export const PawPrint = ({ size = 40, color = '#FF8C42' }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill={color}>
    <ellipse cx="17" cy="10" rx="5" ry="6" />
    <ellipse cx="31" cy="10" rx="5" ry="6" />
    <ellipse cx="9" cy="22" rx="4.5" ry="5.5" />
    <ellipse cx="39" cy="22" rx="4.5" ry="5.5" />
    <path d="M24 45c-8 0-14-8-14-14s6-10 14-10 14 4 14 10-6 14-14 14z" />
  </svg>
);

export const Bone = ({ size = 40, color = '#8B5CF6' }) => (
  <svg width={size} height={size} viewBox="0 0 48 28" fill={color}>
    <path d="M10 4a6 6 0 0 1 5 9.3L29 14.7a6 6 0 1 1 0 8.6L15 22.7A6 6 0 1 1 10 4z" />
    <rect x="12" y="10" width="24" height="8" rx="4" />
    <path d="M38 4a6 6 0 0 1-5 9.3L19 14.7a6 6 0 1 1 0 8.6L33 22.7A6 6 0 1 1 38 4z" />
  </svg>
);

export const FishTreat = ({ size = 36, color = '#20B2AA' }) => (
  <svg width={size} height={size} viewBox="0 0 48 32" fill={color}>
    <path d="M36 16c0 8-10 14-20 14S0 24 0 16 6 2 16 2s20 6 20 14z" />
    <path d="M36 16l12-10v20z" />
    <circle cx="10" cy="14" r="2" fill="white" />
  </svg>
);

export const Ball = ({ size = 32, color = '#FF8C42' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="14" fill={color} />
    <path d="M8 8 Q16 2 24 8 Q30 16 24 24 Q16 30 8 24 Q2 16 8 8z" stroke="white" strokeWidth="1.5" fill="none" opacity="0.4" />
    <circle cx="12" cy="12" r="3" fill="white" opacity="0.3" />
  </svg>
);

export const Bowl = ({ size = 40, color = '#F57C00' }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 48 34" fill={color}>
    <path d="M4 12h40l-4 18a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4L4 12z" />
    <ellipse cx="24" cy="12" rx="22" ry="6" />
  </svg>
);

export const Collar = ({ size = 36, color = '#7C3AED' }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 48 28" fill={color}>
    <path d="M2 14C2 7.4 9.2 2 18 2h12c8.8 0 16 5.4 16 12s-7.2 12-16 12H18C9.2 26 2 20.6 2 14z" />
    <circle cx="24" cy="14" r="4" fill="#FFD700" />
    <rect x="6" y="10" width="36" height="8" rx="4" opacity="0.3" fill="white" />
  </svg>
);

export const YarnBall = ({ size = 32, color = '#A78BFA' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill={color}>
    <circle cx="16" cy="16" r="14" />
    <path d="M6 16 Q10 8 16 6 Q22 8 26 16 Q22 24 16 26 Q10 24 6 16z" stroke="white" strokeWidth="1" fill="none" opacity="0.3" />
    <path d="M8 10 Q16 6 24 10" stroke="white" strokeWidth="1" fill="none" opacity="0.25" />
    <path d="M8 22 Q16 26 24 22" stroke="white" strokeWidth="1" fill="none" opacity="0.25" />
  </svg>
);

export const Heart = ({ size = 28, color = '#FF6B6B' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

// Parallax Background Component
export default function ParallaxBackground() {
  const props = [
    { Component: PawPrint, x: '5%', y: '10%', size: 45, color: '#FF8C42', delay: 0 },
    { Component: Bone, x: '85%', y: '8%', size: 38, color: '#8B5CF6', delay: 1 },
    { Component: Ball, x: '15%', y: '35%', size: 30, color: '#20B2AA', delay: 2 },
    { Component: FishTreat, x: '75%', y: '30%', size: 34, color: '#FF8C42', delay: 0.5 },
    { Component: Bowl, x: '45%', y: '15%', size: 36, color: '#A78BFA', delay: 1.5 },
    { Component: PawPrint, x: '90%', y: '55%', size: 35, color: '#F57C00', delay: 3 },
    { Component: Collar, x: '10%', y: '65%', size: 32, color: '#7C3AED', delay: 2.5 },
    { Component: YarnBall, x: '60%', y: '70%', size: 28, color: '#FF8C42', delay: 1 },
    { Component: Heart, x: '30%', y: '80%', size: 26, color: '#FF6B6B', delay: 0 },
    { Component: Bone, x: '50%', y: '50%', size: 42, color: '#20B2AA', delay: 2 },
    { Component: PawPrint, x: '70%', y: '85%', size: 38, color: '#8B5CF6', delay: 1.5 },
    { Component: Ball, x: '25%', y: '52%', size: 26, color: '#F57C00', delay: 3 },
  ];

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {props.map((p, i) => (
        <div
          key={i}
          className="parallax-prop animate-float-slow"
          style={{
            left: p.x,
            top: p.y,
            animationDelay: `${p.delay}s`,
            animationDuration: `${6 + (i % 4) * 2}s`,
          }}
        >
          <p.Component size={p.size} color={p.color} />
        </div>
      ))}
    </div>
  );
}
